// extracted by mini-css-extract-plugin
export var buttons = "EditSalesModal-module--buttons--O5GhC";
export var container = "EditSalesModal-module--container--cVbPr";
export var welcomeContent = "EditSalesModal-module--welcomeContent--DB2Ut";